export function shareToPercentage(share: number): string {
    const pct = Math.round(share * 100);
    return String(pct);
}
